import React, { type ReactNode } from 'react';

import { Tabs } from '@garnish/layout';

import { ORDER_AGAIN_TABS } from '../../OrderAgain.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const OrderAgainFavoritesTab = (props: OrderAgainOrdersTabProps) => {
  const { children, activeTabId } = props;

  return (
    <Tabs.Panel
      tabId={ORDER_AGAIN_TABS.FAVORITES.ID}
      panelId={ORDER_AGAIN_TABS.FAVORITES.PANEL_ID}
      isActive={activeTabId === ORDER_AGAIN_TABS.FAVORITES.ID}
    >
      {children}
    </Tabs.Panel>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderAgainOrdersTabProps = {
  activeTabId: string;
  children: ReactNode;
};
